import useSWR from 'swr'

import { config } from 'lib/config'
import { store } from 'lib/store'
import type { Rule } from 'types/rules'

export function useRules() {
	const { data, error, mutate } = useSWR<Rule[]>(`${config.apiURL}/v1.0/rules`)

	if (error) {
		store.dispatch({
			type: 'toast/set',
			payload: { kind: 'error', timeout: 6000, message: 'Something went wrong' },
		})
	}

	return {
		rules: data,
		isLoading: !error && !data,
		isError: error,
		mutateRules: mutate,
	}
}
